import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {factory} from '../shared/app-logging';

const logger = factory.getLogger('ErrorDataService');

@Injectable({
  providedIn: 'root'
})
export class ErrorDataService {

  private errorSource = new BehaviorSubject<Error>(null);
  currentError = this.errorSource.asObservable();

  public static overLoadError(err: Error | HttpErrorResponse, message: string, concatMessage = true): Error | HttpErrorResponse {
    const errMessage = message ? message + (concatMessage ? ' ' + err.message : '') : err.message;
    const error = new Error(errMessage);
    logger.debug(message, error);
    if (err instanceof HttpErrorResponse) {
      return new HttpErrorResponse({
        error: error,
        headers: err.headers,
        status: err.status,
        statusText: err.statusText + ` ${message}`,
        url: err.url
      });
    } else {
      return error;
    }
  }

  constructor() {
  }

  setError(err: Error) {
    this.errorSource.next(err);
  }

  clearError() {
    this.setError(null);
  }
}
